/**
 * Chess4pro · Grandmaster Tournament E-Commerce Interaction Engine
 * Clean, Lightweight, Mobile-First UX · Zero Emojis
 * Ulises Standards
 */

(function() {
  'use strict';

  // =========================================================================
  // 1. Repertoire Instant Filter, In-situ Expander & Live Search Engine
  // =========================================================================
  function initRepertoireCatalog() {
    var searchInput = document.getElementById('repSearchInput');
    var filterPills = document.querySelectorAll('.rep-filter-pill');
    var items = document.querySelectorAll('.js-rep-item');
    var resultsCountEl = document.getElementById('repResultsCount');
    var noResultsEl = document.getElementById('repNoResults');
    var resetBtn = document.getElementById('repResetBtn');
    var toggleExpandBtn = document.getElementById('repToggleExpandBtn');
    var expandBtnText = document.getElementById('repExpandBtnText');
    var expandContainer = document.getElementById('repExpandContainer');
    var sectionEl = document.querySelector('.repertoire-selector-section');

    if (!items.length) return;

    var currentFilter = 'all';
    var currentQuery = '';
    var isExpanded = false;

    function filterItems() {
      var visibleCount = 0;
      var isDefaultAllView = (currentFilter === 'all' && !currentQuery);

      items.forEach(function(item) {
        var category = item.getAttribute('data-category') || '';
        var title = (item.getAttribute('data-title') || '').toLowerCase();
        var isCanonical = item.getAttribute('data-canonical') === 'true';

        var matchesCat = (currentFilter === 'all') || (category === currentFilter);
        var matchesQuery = !currentQuery || (title.indexOf(currentQuery) !== -1);

        if (matchesCat && matchesQuery) {
          if (isDefaultAllView && !isExpanded) {
            if (isCanonical) {
              item.style.display = '';
              visibleCount++;
            } else {
              item.style.display = 'none';
            }
          } else {
            item.style.display = '';
            visibleCount++;
          }
        } else {
          item.style.display = 'none';
        }
      });

      if (resultsCountEl) {
        if (isDefaultAllView) {
          if (isExpanded) {
            resultsCountEl.textContent = 'Showing all ' + visibleCount + ' opening repertoires';
          } else {
            resultsCountEl.textContent = 'Showing 8 popular openings';
          }
        } else if (currentFilter !== 'all' && !currentQuery) {
          resultsCountEl.textContent = 'Showing ' + visibleCount + ' openings in selected category';
        } else {
          resultsCountEl.textContent = 'Showing ' + visibleCount + ' of ' + items.length + ' openings found';
        }
      }

      if (expandContainer) {
        if (isDefaultAllView) {
          expandContainer.style.display = 'flex';
          if (expandBtnText) {
            expandBtnText.textContent = isExpanded ? 'Show Less (8 Canonical Openings)' : 'Explore All 41 Repertoires (+33)';
          }
        } else {
          expandContainer.style.display = 'none';
        }
      }

      if (noResultsEl) {
        if (visibleCount === 0) {
          noResultsEl.classList.remove('hide');
        } else {
          noResultsEl.classList.add('hide');
        }
      }
    }

    // In-situ Toggle Expand Button
    if (toggleExpandBtn) {
      toggleExpandBtn.addEventListener('click', function(e) {
        e.preventDefault();
        isExpanded = !isExpanded;
        if (sectionEl) {
          if (isExpanded) {
            sectionEl.classList.add('is-expanded');
          } else {
            sectionEl.classList.remove('is-expanded');
            sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        filterItems();
      });
    }

    // Category Tabs
    filterPills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        filterPills.forEach(function(p) {
          p.classList.remove('active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-selected', 'true');

        currentFilter = pill.getAttribute('data-filter') || 'all';
        filterItems();
      });
    });

    // Search Input
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        currentQuery = searchInput.value.trim().toLowerCase();
        filterItems();
      });
    }

    // Reset Button
    if (resetBtn) {
      resetBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (searchInput) searchInput.value = '';
        currentQuery = '';
        currentFilter = 'all';
        isExpanded = false;
        if (sectionEl) sectionEl.classList.remove('is-expanded');
        filterPills.forEach(function(p) {
          p.classList.remove('active');
          p.setAttribute('aria-selected', 'false');
        });
        var allPill = document.querySelector('.rep-filter-pill[data-filter="all"]');
        if (allPill) {
          allPill.classList.add('active');
          allPill.setAttribute('aria-selected', 'true');
        }
        filterItems();
      });
    }

    // Initial Filter Run
    filterItems();

    // Quick 1-Tap Add to Cart for individual mugs
    var addButtons = document.querySelectorAll('.js-rep-add-to-cart');
    addButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var productTitle = btn.getAttribute('data-product-title') || 'Opening Repertoire Mug';
        if (!variantId || btn.disabled) return;

        var origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart addition failed');
          return res.json();
        })
        .then(function(item) {
          btn.textContent = 'Added to Cart';
          btn.style.background = '#4ade80';
          btn.style.color = '#030611';
          btn.style.borderColor = '#4ade80';

          // Update header cart count
          updateCartBubbleCount();

          // Open unified Cart Drawer
          if (window.C4PCartDrawer) {
            window.C4PCartDrawer.open();
          }

          // GA4 event
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'USD',
                value: 23.00,
                items: [{
                  item_id: variantId,
                  item_name: productTitle,
                  price: 23.00,
                  quantity: 1
                }]
              }
            });
          }

          setTimeout(function() {
            btn.textContent = origText;
            btn.disabled = false;
            btn.style.background = '';
            btn.style.color = '';
            btn.style.borderColor = '';
          }, 2200);
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          btn.textContent = 'Unavailable';
          setTimeout(function() {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
        });
      });
    });
  }

  // =========================================================================
  // 2. Dual Arsenal Builder (2-Step Volume Privilege CRO)
  // =========================================================================
  function initDualArsenalBuilder() {
    var whiteSelect = document.getElementById('arsenalWhiteSelect');
    var blackSelect = document.getElementById('arsenalBlackSelect');
    var duoPriceEl = document.getElementById('arsenalDuoPrice');
    var savingsEl = document.getElementById('arsenalSavings');
    var buyDuoBtn = document.getElementById('arsenalAcquireBtn');

    var whiteImg = document.getElementById('arsenalWhiteImg');
    var whiteTitle = document.getElementById('arsenalWhiteTitle');
    var whiteEco = document.getElementById('arsenalWhiteEco');
    var whiteDesc = document.getElementById('arsenalWhiteDesc');

    var blackImg = document.getElementById('arsenalBlackImg');
    var blackTitle = document.getElementById('arsenalBlackTitle');
    var blackEco = document.getElementById('arsenalBlackEco');
    var blackDesc = document.getElementById('arsenalBlackDesc');

    var presetButtons = document.querySelectorAll('.c4p-preset-pill');

    if (!whiteSelect || !blackSelect || !buyDuoBtn) return;

    function updateSlot(selectEl, imgEl, titleEl, ecoEl, descEl) {
      if (!selectEl.options || selectEl.selectedIndex < 0) return;
      var opt = selectEl.options[selectEl.selectedIndex];
      if (!opt) return;

      var title = opt.getAttribute('data-title') || opt.text;
      var img = opt.getAttribute('data-img');
      var eco = opt.getAttribute('data-eco');
      var desc = opt.getAttribute('data-desc');

      if (titleEl) titleEl.textContent = title;
      if (ecoEl && eco) ecoEl.textContent = eco;
      if (descEl && desc) descEl.textContent = desc;

      if (imgEl && img) {
        imgEl.style.opacity = '0.3';
        imgEl.style.transform = 'scale(0.96)';
        setTimeout(function() {
          imgEl.src = img;
          imgEl.style.opacity = '1';
          imgEl.style.transform = 'scale(1)';
        }, 120);
      }
    }

    function updateArsenal() {
      updateSlot(whiteSelect, whiteImg, whiteTitle, whiteEco, whiteDesc);
      updateSlot(blackSelect, blackImg, blackTitle, blackEco, blackDesc);

      var whiteVariant = whiteSelect.value;
      var blackVariant = blackSelect.value;

      if (whiteVariant && blackVariant) {
        if (duoPriceEl) duoPriceEl.textContent = '$41.40 USD';
        if (savingsEl) savingsEl.textContent = 'Direct $4.60 USD Automatic Savings';
        buyDuoBtn.disabled = false;
        buyDuoBtn.textContent = 'Add Dual Set to Cart · $41.40 USD';
      }
    }

    whiteSelect.addEventListener('change', updateArsenal);
    blackSelect.addEventListener('change', updateArsenal);

    // Preset chips
    presetButtons.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        presetButtons.forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');

        var whiteHandle = pill.getAttribute('data-white-handle') || '';
        var blackHandle = pill.getAttribute('data-black-handle') || '';
        var whiteMatch = (pill.getAttribute('data-white-match') || '').toLowerCase();
        var blackMatch = (pill.getAttribute('data-black-match') || '').toLowerCase();

        if (whiteHandle || whiteMatch) {
          for (var i = 0; i < whiteSelect.options.length; i++) {
            var optHandle = whiteSelect.options[i].getAttribute('data-handle') || '';
            var optText = whiteSelect.options[i].text.toLowerCase();
            if ((whiteHandle && optHandle === whiteHandle) || (whiteMatch && optText.indexOf(whiteMatch) !== -1)) {
              whiteSelect.selectedIndex = i;
              break;
            }
          }
        }

        if (blackHandle || blackMatch) {
          for (var j = 0; j < blackSelect.options.length; j++) {
            var optHandleB = blackSelect.options[j].getAttribute('data-handle') || '';
            var optTextB = blackSelect.options[j].text.toLowerCase();
            if ((blackHandle && optHandleB === blackHandle) || (blackMatch && optTextB.indexOf(blackMatch) !== -1)) {
              blackSelect.selectedIndex = j;
              break;
            }
          }
        }

        updateArsenal();
      });
    });

    // Initial sync
    updateArsenal();

    // 1-Click Batch Add to Cart
    buyDuoBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var wId = whiteSelect.value;
      var bId = blackSelect.value;
      if (!wId || !bId) return;

      var origText = buyDuoBtn.textContent;
      buyDuoBtn.disabled = true;
      buyDuoBtn.textContent = 'Adding to Cart...';

      var itemsToAdd = [
        { id: parseInt(wId, 10), quantity: 1 },
        { id: parseInt(bId, 10), quantity: 1 }
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Dual bundle addition failed');
        return res.json();
      })
      .then(function() {
        buyDuoBtn.textContent = 'Dual Set Added';
        updateCartBubbleCount();

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'USD',
              value: 41.40,
              items: [
                { item_id: wId, item_name: whiteSelect.options[whiteSelect.selectedIndex].text, price: 20.70, quantity: 1 },
                { item_id: bId, item_name: blackSelect.options[blackSelect.selectedIndex].text, price: 20.70, quantity: 1 }
              ]
            }
          });
        }
        if (window.C4PCartDrawer) {
          window.C4PCartDrawer.open();
          setTimeout(function() {
            buyDuoBtn.textContent = 'Add Dual Set to Cart · $41.40 USD';
            buyDuoBtn.disabled = false;
          }, 1500);
        } else {
          window.location.href = '/checkout?discount=REPERTOIRE10';
        }
      })
      .catch(function(err) {
        console.error('Dual bundle addition error:', err);
        buyDuoBtn.textContent = origText;
        buyDuoBtn.disabled = false;
      });
    });
  }

  // =========================================================================
  // 3. Cart Count Synchronization Helper
  // =========================================================================
  function updateCartBubbleCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('[data-cart-count], #CartCount span');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.getElementById('CartCount');
        if (bubble) {
          if (cart.item_count > 0) {
            bubble.classList.remove('hide');
          } else {
            bubble.classList.add('hide');
          }
        }
      })
      .catch(function() {});
  }

  // =========================================================================
  // 4. Smooth Anchor Scrolling with Header Compensation
  // =========================================================================
  function initSmoothAnchors() {
    var anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (href === '#' || href === '#!') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var headerHeight = 70;
          var header = document.querySelector('.site-header');
          if (header) headerHeight = header.offsetHeight;

          var targetPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 12;
          window.scrollTo({
            top: targetPos,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // =========================================================================
  // 5. Global Product Form ATC Interception to Cart Drawer
  // =========================================================================
  function initAjaxCartInterception() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
        // Native product forms are handled by theme.js Product component; avoid double addition
        if (form.hasAttribute('data-product-form') || form.classList.contains('product-form')) {
          return;
        }
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"], .product-form__cart-submit');
        var origText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          if (submitBtn) {
            submitBtn.textContent = origText;
            submitBtn.disabled = false;
          }
          if (window.C4PCartDrawer) {
            window.C4PCartDrawer.open();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          if (submitBtn) {
            submitBtn.textContent = origText;
            submitBtn.disabled = false;
          }
          form.submit();
        });
      }
    });
  }

  // =========================================================================
  // 6. Product Quantity Selector Controller (PDP & Forms)
  // =========================================================================
  function initQuantitySelectors() {
    document.addEventListener('click', function(e) {
      var plusBtn = e.target.closest('.qtyplus, .qty-btn--plus, [data-quantity-plus], #qtyPlus');
      var minusBtn = e.target.closest('.qtyminus, .qty-btn--minus, [data-quantity-minus]');

      if (plusBtn || minusBtn) {
        if (e._c4p_qty_handled) return;
        e._c4p_qty_handled = true;
      }

      if (plusBtn) {
        e.preventDefault();
        var container = plusBtn.closest('.qty_selector') || plusBtn.parentElement;
        var input = container ? container.querySelector('input[name="quantity"], .product-form__input--quantity') : null;
        if (!input && plusBtn.previousElementSibling && (plusBtn.previousElementSibling.tagName === 'INPUT')) {
          input = plusBtn.previousElementSibling;
        }
        if (input) {
          var val = parseInt(input.value, 10);
          if (isNaN(val) || val < 1) val = 1;
          input.value = val + 1;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (minusBtn) {
        e.preventDefault();
        var container = minusBtn.closest('.qty_selector') || minusBtn.parentElement;
        var input = container ? container.querySelector('input[name="quantity"], .product-form__input--quantity') : null;
        if (!input && minusBtn.nextElementSibling && (minusBtn.nextElementSibling.tagName === 'INPUT')) {
          input = minusBtn.nextElementSibling;
        }
        if (input) {
          var val = parseInt(input.value, 10);
          if (isNaN(val) || val <= 1) {
            input.value = 1;
          } else {
            input.value = val - 1;
          }
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  // =========================================================================
  // 7. Lifecycle Entry
  // =========================================================================
  document.addEventListener('DOMContentLoaded', function() {
    initRepertoireCatalog();
    initDualArsenalBuilder();
    initSmoothAnchors();
    initAjaxCartInterception();
    initQuantitySelectors();
  });

})();
